import script from "./AddWritersTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddWritersTab.vue?vue&type=script&setup=true&lang=ts"

import "./AddWritersTab.vue?vue&type=style&index=0&id=b937f69c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b937f69c"]])

export default __exports__